import React from 'react';

import { T } from '../../../../../../../../common/locale/translate';
import Table from '../../../../../../common/components/responsive-table';
import Offer from '../../../../../../common/components/offer-list-element';
import { prepareOfferUniqueKey } from '../../../../../../services/services';

export default class Flight extends React.Component {
  constructor() {
    super();
    this.state = {
      C1: { headers: 'flightOneWay', className: 'flight-one-way' },
      C2: { headers: 'flightTwoWays', className: 'flight-two-ways' },
      flightTwoWays: [
        { name: 'route', title: T('departure_place') },
        { name: 'provider', title: T('operator_short') },
        { name: 'duration', title: T('admin_special_offers_duration') },
        { name: 'departure_details', title: T('departure_date') },
        { name: 'arrival_details', title: T('arrival_date') },
        { name: 'price', title: T('price_quality') }
      ],
      flightOneWay: [
        { name: 'route', title: T('departure_place') },
        { name: 'provider', title: T('operator') },
        { name: 'departure_details', title: T('departure_date') },
        { name: 'price', title: T('price_quality') }
      ],
      availabilityCheckNumber: 5
    };
  }

  render() {
    const option = this.state[this.props.offer_type];
    return (
      <div>
        <section className={`flight-component ${option.className}`}>
          <Table headers={this.state[option.headers]}>
            {this.props.data.map((flight, i) => {
              flight.uuid = flight.id;
              const tableRowKey = `${prepareOfferUniqueKey(flight)}-${i}`;
              return (
                <Offer
                  key={tableRowKey}
                  tableRowKey={tableRowKey}
                  data={flight}
                  checkAvailability={true}
                  params={this.props.params}
                  shouldRenderWhenUnavailable
                />
              );
            })}
          </Table>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/components/offers_list/components/flight/index.js